import { updateNewUserExperience } from '../../../modules/auth/AuthApi';

export const updateNewUserExperienceUseCase = async () => {
  await updateNewUserExperience();
};
